import { z } from 'zod';

export const SaveTemplateSchema = z.object({
  ten_maubc: z.string().min(1, 'Tên báo cáo không được để trống'),
  ten_maubc2: z.string().optional().nullable()
});

export type SaveTemplate = z.infer<typeof SaveTemplateSchema>;

export const DetailTemplateSchema = z.object({
  stt: z.coerce.number(),
  stt_in: z.coerce.number().nullable().optional(),
  ma_so: z.string().min(1, 'Bắt buộc nhập'),
  ma_in: z.string().optional(),
  chi_tieu: z.string().min(1, 'Chỉ tiêu không được để trống'),
  chi_tieu2: z.string().optional(),
  chi_tieu3: z.string().optional(),
  thuyet_minh: z.string().optional(),
  ts_nv: z.string().optional(),
  in_yn: z.string().optional(),
  bold_yn: z.string().optional(),
  loai: z.string().optional(),
  no_co: z.string().optional(),
  dau_cuoi: z.string().optional(),
  cong_no: z.string().optional(),
  dau: z.string().optional(),
  tk: z.array(z.string()).optional(),
  tk_du: z.array(z.string()).optional(),
  tk_gt: z.array(z.string()).optional(),
  cong_thuc: z.string().optional(),
  dieu_kien_khac: z
    .array(
      z.object({
        id_dt_loc: z.number(),
        ds_loc: z.array(z.string())
      })
    )
    .optional()
});

export type DetailTemplate = z.infer<typeof DetailTemplateSchema>;

export const detailInitialValues: DetailTemplate = {
  stt: 0,
  stt_in: 0,
  ma_so: '',
  ma_in: '',
  chi_tieu: '',
  chi_tieu2: '',
  chi_tieu3: '',
  thuyet_minh: '',
  ts_nv: '1',
  in_yn: '1',
  bold_yn: '1',
  loai: '1',
  no_co: '1',
  dau_cuoi: '1',
  cong_no: '0',
  dau: '0',
  cong_thuc: '',
  dieu_kien_khac: []
};
